/**
 * Utility per la compilazione della descrizione delle righe configurate
 * (sia preventivo che ordine — D80/D81).
 *
 * - compilaDescrizioneTemplate: sostituisce i placeholder {componente_N} di un
 *   ModelloConfigurazione con la descrizione del componente derivato dallo
 *   slot di ordine N. Placeholder senza match restano com'erano (stesso
 *   comportamento dell'anteprima della pagina Modelli).
 * - proponiDescrizioneDaComponenti: concatenazione delle sole descrizioni
 *   articolo dei componenti isInDescrizione, una per riga, SENZA quantita ne
 *   UM (D81). Testo destinato alla fattura a forfait.
 * - proponiDescrizione: dispatcher su sorgente (D72).
 */

export interface ComponenteDescrizione {
  /** Ordine dello slot del modello da cui deriva il componente (null se libero/preconf). */
  slotOrdine: number | null;
  /** Descrizione articolo scelto (descrizioneBase), o etichetta slot se non ancora scelto. */
  descrizione: string;
  isInDescrizione: boolean;
}

/**
 * Compila un descrizioneTemplate di ModelloConfigurazione sostituendo i
 * placeholder {componente_N} (N = ordine dello slot) con la descrizione del
 * componente che deriva da quello slot. Placeholder senza componente
 * corrispondente: resta com'e (segnale visivo per l'operatore, stesso
 * comportamento dell'anteprima della pagina Modelli).
 */
export function compilaDescrizioneTemplate(
  template: string,
  componenti: ComponenteDescrizione[],
): string {
  return template.replace(/\{componente_(\d+)\}/g, (match, n) => {
    const slot = parseInt(n, 10);
    const comp = componenti.find((c) => c.slotOrdine === slot);
    return comp && comp.descrizione ? comp.descrizione : match;
  });
}

/**
 * Proposta automatica per sorgente NON-modello (D81): concatenazione delle
 * sole descrizioni articolo dei componenti isInDescrizione, una per riga,
 * SENZA quantita ne UM.
 */
export function proponiDescrizioneDaComponenti(
  componenti: ComponenteDescrizione[],
): string {
  return componenti
    .filter((c) => c.isInDescrizione && c.descrizione)
    .map((c) => c.descrizione)
    .join('\n');
}

/**
 * Proposta complessiva (D72): template del modello se presente e sorgente
 * MODELLO, altrimenti concatenazione.
 */
export function proponiDescrizione(
  sorgenteTipo: 'MODELLO' | 'PRECONFIGURATO' | 'LIBERA',
  descrizioneTemplate: string | null | undefined,
  componenti: ComponenteDescrizione[],
): string {
  if (
    sorgenteTipo === 'MODELLO' &&
    descrizioneTemplate &&
    descrizioneTemplate.trim() !== ''
  ) {
    return compilaDescrizioneTemplate(descrizioneTemplate, componenti);
  }
  return proponiDescrizioneDaComponenti(componenti);
}
